export const photos = [
  {
    src: "/images/phil1.jpg",
    width: 4,
    height: 3
  },
  {
    src: "/images/phil2.jpg",
    width: 1,
    height: 1
  },
  {
    src: "/images/phil5.jpg",
    width: 3,
    height: 4
  },
  {
    src: "/images/phil6.jpg",
    width: 3,
    height: 4
  },
  {
    src: "/images/phil7.jpg",
    width: 4,
    height: 3
  },
  {
    src: "/images/phil3.jpg",
    width: 4,
    height: 3
  },
  {
    src: "/images/phil4.jpg",
    width: 4,
    height: 3
  },
  {
    src: "/images/phil8.jpg",
    width: 4,
    height: 3
  },
  {
    src: "/images/phil9.jpg",
    width: 4,
    height: 3
  },
  {
    src: "/images/filo1.jpg",
    width: 4,
    height: 3
  },
  {
    src: "/images/filo2.jpg",
    width: 4,
    height: 3
  },
  {
    src: "/images/filo3.jpg",
    width: 4,
    height: 3
  },
  {
    src: "/images/filo4.jpg",
    width: 4,
    height: 3
  },
  {
    src: "/images/filo5.jpg",
    width: 4,
    height: 3
  },
  {
    src: "/images/filo6.jpg",
    width: 4,
    height: 3
  },
  {
    src: "/images/filo7.jpg",
    width: 4,
    height: 3
  },
  {
    src: "/images/filo8.jpg",
    width: 4,
    height: 3
  },
  {
    src: "/images/filo9.jpg",
    width: 4,
    height: 3
  },
  {
    src: "/images/filo10.jpg",
    width: 4,
    height: 3
  }
];
